export default __webpack_public_path__ + "e0f2a1e47f2a72fa47e6e7086bc02ac5.webp";